"use strict";
(function (global) {
  /**
   * Фабрика параметров прикладного метода.
   * 
   * @private 
   * @class WA.domainMethods.VariantParameterFactory
   * @since 5.5.0.1000
   */
  var VariantParameterFactory = Class.extend({
    className: "VariantParameterFactory",

    /**
     * Создает параметр прикладного метода.
     * @param {object} parameter 
     * @returns {WA.VariantParameter} 
     */
    сreateVariantParameter: function (parameter) {
      switch (typeof parameter) {
        case "number":
          return this.сreateVariantParameterFromNumber(parameter);
        case "boolean":
          return this.сreateVariantParameterFromBoolean(parameter);
        case "string":
          return this.сreateVariantParameterFromString(parameter);
        case "object":
          return this.сreateVariantParameterFromObject(parameter);
        default:
          throw new Error("Unknown type of parameter.");
      }
    },

    /**
     * Создает параметр прикладного метода из числа.
     * @param {number} number 
     * @returns {WA.VariantParameter} 
     */
    сreateVariantParameterFromNumber: function (number) {
      return new global.VariantParameter(number, VARIANT_TYPE.SINGLE, "");
    },

    /**
     * Создает параметр прикладного метода из логического типа.
     * @param {boolean} boolean 
     * @returns {WA.VariantParameter} 
     */
    сreateVariantParameterFromBoolean: function (boolean) {
      return new global.VariantParameter(boolean, VARIANT_TYPE.BOOLEAN, "");
    },

    /**
     * Создает параметр прикладного метода из даты.
     * @param {Date} date 
     * @returns {WA.VariantParameter} 
     */
    сreateVariantParameterFromDate: function (date) {
      return new global.VariantParameter(date, VARIANT_TYPE.DATE_TIME, "");
    },

    /**
     * Создает параметр прикладного метода из строки.
     * @param {string} string 
     * @returns {WA.VariantParameter} 
     */
    сreateVariantParameterFromString: function (string) {
      //пытаемся получить из строки число
      var re = new RegExp(/^-?\d*(\.\d+)?$/);
      var isNumber = re.test(string);
      if (isNumber) {
        return this.сreateVariantParameterFromNumber(parseFloat(string));
      }

      //пытаемся получить из строки дату
      var date = parseDateTime(string);
      if (date !== null) {
        return this.сreateVariantParameterFromDate(date);
      }

      return new global.VariantParameter(string, VARIANT_TYPE.STRING, "");
    },

    /**
     * Создает параметр прикладного метода из переменной типа object.
     * @param {object} obj 
     * @returns {WA.VariantParameter} 
     */
    сreateVariantParameterFromObject: function (obj) {
      var me = this;

      if (obj instanceof Date) {
        return this.сreateVariantParameterFromDate(obj);
      }

      if (obj instanceof WA.Link) {
        var parameterType = getVariantTypeFromLinkType(obj.type);
        return new global.VariantParameter(obj.id, parameterType, "");
      }

      if (obj instanceof Array) {
        var variantParameters = obj.map(function (item) {
          return me.сreateVariantParameter(item);
        });
        var parameterValue = variantParameters.map(function (item) {
          return item.value;
        });
        return new global.VariantParameter(parameterValue, getVariantCollectionTypeFromVariantType(variantParameters[0].type), "");
      }

      return null;
    }
  });

  /**
   * Возвращает тип параметра прикладного метода, соответствующий типу ссылки.
   * @param {OBJECT_TYPE} linkType тип объекта ссылки
   * @returns {VARIANT_TYPE} тип параметра прикладного метода
   */
  function getVariantTypeFromLinkType(linkType) {
    switch (linkType) {
      case OBJECT_TYPE.EDOCUMENT:
        return VARIANT_TYPE.DOCUMENT;
      case OBJECT_TYPE.FOLDER:
        return VARIANT_TYPE.FOLDER;
      case OBJECT_TYPE.TASK:
        return VARIANT_TYPE.TASK;
      case OBJECT_TYPE.JOB:
        return VARIANT_TYPE.JOB;
      case OBJECT_TYPE.REFERENCE_RECORD:
        return VARIANT_TYPE.REFERENCE_RECORD;
      default:
        return null;
    }
  };

  /**
   * Возвращает тип параметра прикладного метода для коллекции, соответствующий единичному типу.
   * @param {VARIANT_TYPE} type единичный тип параметра
   * @returns {VARIANT_TYPE} тип параметра для коллекции 
   */
  function getVariantCollectionTypeFromVariantType(type) {
    switch (type) {
      case VARIANT_TYPE.INTEGER:
        return VARIANT_TYPE.INTEGER_COLLECTION;
      case VARIANT_TYPE.SINGLE:
        return VARIANT_TYPE.SINGLE_COLLECTION;
      case VARIANT_TYPE.STRING:
        return VARIANT_TYPE.STRING_COLLECTION;
      case VARIANT_TYPE.BOOLEAN:
        return VARIANT_TYPE.BOOLEAN_COLLECTION;
      case VARIANT_TYPE.DATE_TIME:
        return VARIANT_TYPE.DATE_TIME_COLLECTION;
      case VARIANT_TYPE.TASK:
        return VARIANT_TYPE.TASK_COLLECTION;
      case VARIANT_TYPE.JOB:
        return VARIANT_TYPE.JOB_COLLECTION;
      case VARIANT_TYPE.FOLDER:
        return VARIANT_TYPE.FOLDER_COLLECTION;
      case VARIANT_TYPE.DOCUMENT:
        return VARIANT_TYPE.DOCUMENT_COLLECTION;
      case VARIANT_TYPE.REFERENCE_RECORD:
        return VARIANT_TYPE.REFERENCE_RECORD_COLLECTION;
      case VARIANT_TYPE.USER:
        return VARIANT_TYPE.USER_COLLECTION;
      case VARIANT_TYPE.USER_GROUP:
        return VARIANT_TYPE.USER_GROUP_COLLECTION;
      case VARIANT_TYPE.USER_ROLE:
        return VARIANT_TYPE.USER_ROLE_COLLECTION;
      default:
        return null;
    }
  }

  /**
   * Экземпляр фабрики параметров прикладного метода.
   * 
   * @since 5.5.0.1000
   * @property variantParameterFactory
   * @type {Object}
   */
  global.variantParameterFactory = new VariantParameterFactory();
})(window.WebAccess.domainMethods);